<script lang="ts" setup>
const {
  onHandleAlert,
  offHandleAlert,
  onHandleForceCloseAllTheDialog,
  offHandleForceCloseAllTheDialog,
} = useDialogInit()

const isShow = ref(false)
const dialogAlertOption = ref<IEventBusDialogAlert | null>(null)

onBeforeMount(() => {
  onHandleAlert(handleShow.bind(this))
  onHandleForceCloseAllTheDialog(handleForceClose.bind(this))
})

onBeforeUnmount(() => {
  offHandleAlert(handleShow.bind(this))
  offHandleForceCloseAllTheDialog(handleForceClose.bind(this))
})

const handleShow = (option: IEventBusDialogAlert) => {
  dialogAlertOption.value = {
    ...option,
    bodyScrollLock: option.bodyScrollLock,
  }
  isShow.value = true
}

const handleClickConfirm = () => {
  dialogAlertOption.value?.onConfirm()
  isShow.value = false
}

const handleForceClose = () => {
  isShow.value = false
}
</script>

<template>
  <!-- eslint-disable vue/no-v-html -->
  <BaseDialog
    v-model="isShow"
    footer-fixed
    persistent
    :body-scroll-lock="dialogAlertOption?.bodyScrollLock"
  >
    <template #content>
      <div class="TheDialogAlert__content">
        <div class="TheDialogAlert__contentInner">
          <h3
            v-if="dialogAlertOption?.title"
            class="TheDialogAlert__contentTitle"
            v-html="dialogAlertOption?.title"
          />
          <p
            v-if="dialogAlertOption?.message"
            class="TheDialogAlert__contentMessage"
            v-html="dialogAlertOption?.message"
          />
        </div>
      </div>
    </template>
    <template #footer>
      <div>
        <BaseButtonRectanglePrimary
          :title="dialogAlertOption?.buttonText.confirm"
          size="large"
          blocked
          @click="handleClickConfirm"
        />
      </div>
    </template>
  </BaseDialog>
</template>

<style lang="scss" scoped>
.TheDialogAlert {
  &__content {
    @apply px-[16px] pt-[24px] pb-[16px];

    &Inner {
      @apply text-center;
    }

    &Title {
      @apply subtitle3_bold_medium gray-333--text;
      @apply whitespace-pre-wrap;
      @apply mb-[10px];
    }

    &Message {
      @apply body1_regular_medium gray-666--text;
      @apply whitespace-pre-line;
    }
  }
}
</style>
